import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { tab: String }

  connect() {
    this.selectedPanelId = this.tabValue
    this.updateCurrentTab()
  }

  select(event) {
    event.preventDefault()
    this.selectedPanelId = event.currentTarget.dataset.panel
    this.updateCurrentTab()
  }

  updateCurrentTab() {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.id !== this.selectedPanelId)
    })

    this.tabTargets.forEach((tab) => {
      const isSelected = tab.dataset.panel === this.selectedPanelId
      tab.classList.toggle("tab-active", isSelected)
      tab.setAttribute("aria-selected", isSelected)
    })
  }
}
